import React, { useState, useEffect } from 'react';
import Carousel from '../Carousel/Carousel';
import ContactForm from '../ContactForm/ContactForm';
import { heroCarouselImages } from '../../data/heroCarousel';
import './Hero.css';

const Hero: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      className={`hero ${isVisible ? 'visible' : ''}`}
      id="home"
      aria-labelledby="hero-title"
    >
      {/* Fondo global del hero: foto real de la oficina, levemente difuminada,
          con velo de var(--surface) encima (.hero::before) para que el texto
          mantenga contraste AA en claro y oscuro. */}
      <div className="hero-bg" aria-hidden="true">
        <img
          src="/assets/img/hero/oficina-hero-1400.webp"
          srcSet="/assets/img/hero/oficina-hero-800.webp 800w, /assets/img/hero/oficina-hero-1400.webp 1400w"
          sizes="100vw"
          alt=""
          width={1400}
          height={788}
          fetchPriority="high"
          decoding="async"
        />
      </div>

      <div className="container hero-container">
        {/* Columna izquierda — texto */}
        <div className="hero-text-col">
          <div className="hero-chip" aria-label="Especialidad">
            <span className="hero-chip__dot" aria-hidden="true"></span>
            <span>Santiago · Presencial y online</span>
          </div>

          {/* H1 = qué somos (2026-10-31). El eslogan bajó a .hero-slogan,
              debajo del formulario: el form manda en el primer pantallazo. */}
          <h1 id="hero-title" className="hero-title">
            Centro de terapia{' '}
            <span className="hero-highlight">para parejas</span>
          </h1>

          <p className="hero-subtitle">
            Déjanos tus datos y te contactamos hoy para agendar tu hora.
            Sin juicios, con psicólogos certificados.
          </p>

          {/* Formulario de agendamiento en el hero (campaña Meta, 2026-10-29).
              Reemplaza a la sección "Te contactamos" (LeadSection): el
              <ContactForm> se renderiza UNA sola vez en la página (ids únicos).
              `loaded` dispara la animación .animate-in del formulario. */}
          <div className="hero-form loaded" id="te-contactamos">
            <ContactForm origin="Formulario hero — agendar" showQuickContact={false} />
          </div>

          <p className="hero-slogan">
            El amor no se termina. <span className="hero-slogan__highlight">Se trabaja.</span>
          </p>

          <div className="hero-buttons hero-buttons--compact">
            <span className="hero-buttons__label">¿Prefieres agendar tú?</span>
            <a
              href="/agendar"
              className="hero-cta-primary"
              aria-label="Agendar hora online"
            >
              <i className="fas fa-calendar-check" aria-hidden="true"></i>
              <span>Agenda online</span>
            </a>
            <a
              href="https://wa.me/56978009119?text=Hola!%20Quisiera%20agendar%20una%20consulta.%20%C2%BFTienen%20disponibilidad%3F"
              className="hero-cta-whatsapp"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Agendar por WhatsApp"
            >
              <i className="fab fa-whatsapp" aria-hidden="true"></i>
              <span>WhatsApp</span>
            </a>
          </div>

          <div className="hero-trust-strip">
            <div className="trust-item">
              <strong>5+</strong>
              <span>años de experiencia</span>
            </div>
            <div className="trust-divider" aria-hidden="true"></div>
            <div className="trust-item">
              <strong>+500</strong>
              <span>pacientes atendidos</span>
            </div>
            <div className="trust-divider" aria-hidden="true"></div>
            <div className="trust-item">
              <strong>100%</strong>
              <span>profesionales certificados</span>
            </div>
          </div>
        </div>

        {/* Columna derecha — carrusel de la campaña de Meta (ver heroCarousel.ts). */}
        <div className="hero-image-col">
          <Carousel
            images={heroCarouselImages}
            interval={6000}
            pauseOnHover={true}
            showControls={false}
            showIndicators={true}
            className="hero-promo-carousel"
            ariaLabel="Campañas de Conectemos Chile"
            imgWidth={900}
            imgHeight={1125}
            imgFetchPriority="high"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
